var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2603_213403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2603_213403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 17.3744L12.5896 13.964C12.4071 13.7796 12.179 13.6874 11.9053 13.6874C11.6317 13.6874 11.3957 13.7796 11.1973 13.964C10.9906 14.1625 10.8894 14.4002 10.8936 14.677C10.8978 14.9539 10.999 15.1915 11.1973 15.3897L15.1563 19.3487C15.3974 19.5898 15.6786 19.7104 15.9999 19.7104C16.3213 19.7104 16.6025 19.5898 16.8436 19.3487L20.8229 15.3694C21.0211 15.1709 21.119 14.9367 21.1166 14.6667C21.1139 14.3967 21.0093 14.1625 20.8026 13.964C20.6041 13.7796 20.3699 13.686 20.0999 13.6834C19.8299 13.6809 19.5957 13.7788 19.3973 13.977L15.9999 17.3744ZM16.0023 28.6667C14.2503 28.6667 12.6035 28.3343 11.0619 27.6694C9.52036 27.0045 8.17947 26.1022 7.03925 24.9624C5.89903 23.8226 4.99625 22.4823 4.33092 20.9414C3.66581 19.4005 3.33325 17.7542 3.33325 16.0024C3.33325 14.2504 3.6657 12.6036 4.33059 11.062C4.99547 9.52048 5.89781 8.1796 7.03759 7.03937C8.17736 5.89915 9.5177 4.99637 11.0586 4.33104C12.5995 3.66593 14.2458 3.33337 15.9976 3.33337C17.7496 3.33337 19.3964 3.66582 20.9379 4.33071C22.4795 4.9956 23.8204 5.89793 24.9606 7.03771C26.1008 8.17749 27.0036 9.51782 27.6689 11.0587C28.334 12.5996 28.6666 14.2459 28.6666 15.9977C28.6666 17.7497 28.3341 19.3965 27.6693 20.938C27.0044 22.4796 26.102 23.8205 24.9623 24.9607C23.8225 26.1009 22.4821 27.0037 20.9413 27.669C19.4004 28.3342 17.754 28.6667 16.0023 28.6667ZM15.9999 26.6667C18.9777 26.6667 21.4999 25.6334 23.5666 23.5667C25.6333 21.5 26.6666 18.9778 26.6666 16C26.6666 13.0223 25.6333 10.5 23.5666 8.43337C21.4999 6.36671 18.9777 5.33337 15.9999 5.33337C13.0221 5.33337 10.4999 6.36671 8.43325 8.43337C6.36659 10.5 5.33325 13.0223 5.33325 16C5.33325 18.9778 6.36659 21.5 8.43325 23.5667C10.4999 25.6334 13.0221 26.6667 15.9999 26.6667Z",
    fill: "#E81717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCircleDown);
export default __webpack_public_path__ + "static/media/expand_circle_down.feb627b16770590a2ad79827615ea5a6.svg";
export { ForwardRef as ReactComponent };